angular.module('bb.network').config(NetworkRoutes);

NetworkRoutes.$inject = ['$routeProvider'];
function NetworkRoutes($routeProvider) {
  $routeProvider.when('/listing/network_map', {
    template: require('./network_map.html'),
    controller: 'ListingNetworkMapCtrl',
    reloadOnSearch: false,
  });
}

export {};
